import { FC, useMemo } from 'react';
import { Form, Formik } from 'formik';
import { Button } from '../../../base-components/Button';
import { FormTextArea } from '../../../base-components/FormTextArea';
import { FormTextInput } from '../../../base-components/FormTextInput';
import styles from './SendOrderForm.module.scss';
import { Props } from './SendOrderForm.type';
import Link from 'next/link';
import FormCheckbox from '../../../base-components/Checkbox/FormCheckbox';
import { FormErrorBag } from '../../../base-components/FormErrorBag';

export const SendOrderForm: FC<Props> = ({
    handleSubmit,
    textAreLabel,
    contactLabel = 'Номер телефона',
    validationSchema,
    initialValues: externalValues,
}) => {
    const initialValues = useMemo(() => {
        return {
            inn: '',
            name: '',
            contact: '',
            message: '',
            checkbox: false,
            ...externalValues,
        };
    }, [externalValues]);

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {(formik) => (
                <Form className={styles.form}>
                    <h3>
                        Оставьте заявку и наш менеджер свяжется с вами и
                        проконсультирует по всем интересующим вопросам.{' '}
                    </h3>
                    <h3>
                        {'Или '}
                        <Link
                            href={
                                '/auth/login?backurl=https%3A%2F%2Festp.ru%2Fpersonal%2Fservices'
                            }
                        >
                            <a className={styles.textLink}>
                                Зарегистрироваться / Войти
                            </a>
                        </Link>
                    </h3>
                    <FormTextInput
                        name="inn"
                        appearance="compact"
                        label="ИНН организации"
                        className={styles.field}
                    />
                    <FormTextInput
                        name="name"
                        appearance="compact"
                        label="ФИО"
                        className={styles.field}
                    />
                    <FormTextInput
                        name="contact"
                        appearance="compact"
                        label={contactLabel}
                        className={styles.field}
                    />
                    <FormTextArea
                        name="message"
                        label={textAreLabel}
                        className={styles.message}
                    />
                    <FormErrorBag name="checkbox" className={styles.checkbox}>
                        <FormCheckbox
                            name="checkbox"
                            label="Согласен на обработку персональных данных"
                        />
                    </FormErrorBag>
                    <div className={styles.footer}>
                        <Button
                            variant="blue"
                            disabled={formik.isSubmitting}
                            type="submit"
                            className={styles.sendBtn}
                        >
                            Отправить
                        </Button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};
